import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField'
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import { Row, Col } from 'react-flexbox-grid'
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const EstadosPedido = {
    Borrador: 1,
    Confirmado: 2,
    Preparado: 3,
    Entregado: 4,
    Abandonado: 5,
    Eliminado: 6,
}

const styles = theme => ({
    root: {},
    select: {
        minWidth: "280px",
    },
    rootModal: {
        zIndex: 1200,
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '-5px 4px 10px #8E8E8E29',
        borderRadius: '21px',
        opacity: 1,
        padding: '0px !important',
        minWidth: '300px'
    },
    rootDialog: {
        zIndex: 1250,
    },
})

const filtroTemporal = [
    {
        name: "Últimas 24 horas",
        value: 1
    },
    {
        name: "Últimas 48 horas",
        value: 2
    },
    {
        name: "Última semana",
        value: 3
    },
    {
        name: "Último mes",
        value: 4
    },
    {
        name: "Otro intervalo",
        value: 5
    },
]

const Kpindicator = (props) => {

    return <div style={{ margin: '20px', borderBottom: '1px solid #BDBDBD' }}>
        <Row>
            <Col xs={9}>
                {!props.isTotal ? (<div style={{ color: '#0C3653', fontFamily: 'Roboto', fontSize: '14px', lineHeight: '16px', marginBottom: '12px' }}>{props.name}</div>)
                    : (<div style={{ color: '#0C3653', fontFamily: 'Roboto', fontSize: '14px', lineHeight: '16px', marginBottom: '12px', textTransform: 'uppercase', fontWeight: 'bold' }}>{props.name}</div>)}
            </Col>
            <Col xs={3}>
                {!props.isTotal ? (<div style={{ color: '#0C3653', fontFamily: 'Roboto', fontSize: '14px', lineHeight: '16px', marginBottom: '12px', textAlign: 'right' }}>{props.value || 0}</div>)
                    : (<div style={{ color: '#0C3653', fontFamily: 'Roboto', fontSize: '14px', lineHeight: '16px', marginBottom: '12px', textAlign: 'right', textTransform: 'uppercase', fontWeight: 'bold' }}>{props.value || 0}</div>)}
            </Col>
        </Row>
    </div>

    {/*
            <div 
                onClick={() => props.handleOnClickKpi(props.estado)}
                style={{
                    cursor: "pointer",
                    backgroundColor: props.color,
                    width: "169px",
                    height: "112px",
                    display: "inline-block",
                    marginLeft: "15px",
                    marginBottom:"12px",
                    position: "relative",
                    top:(props.circulo)?"-20px":"0px"
                }}
            >
            {
                (props.circulo)?
                <div style={{
                    width:"90px",
                    height:"90px",
                    borderRadius:"100%",
                    backgroundColor:"#C4C4C4",
                    margin:"auto",
                    position: "relative",
                    top: "11px"
                }}>{
                    props.total > 0 && props.value > 0 &&
                <svg style={{
                    position:"absolute",}}
                    stroke="#C4C4C4"
                    strokeWidth="3px"
                width="92" height="92" >
                <circle style={{stroke:(props.colorBar)?props.colorBar:"#58DB1B",strokeWidth:"4px"}} 
                r={43} cx={45} cy={45} fill="transparent" 
                strokeDasharray={`${270*(props.value/props.total)} 360`} strokeDashoffset=""></circle>
                </svg>}
                <div style={{
                    width:"80px",
                    height:"80px",
                    borderRadius:"100%",
                    backgroundColor:"#FFFFFF",
                    margin:"auto",
                    position: "relative",
                    top: "5px"
                }}>
                <div><div style={{
                    width:"80px",
                    height:"29px",
                    position:"relative",
                    top:"26px",
                    fontFamily:"Roboto",
                    fontSize:"24px",
                    textAlign: "center",
                    color:"#000000"
                }
                }>{props.value}</div>
                <div style={{
                    width:"80px",
                    height:"12px",
                    position:"relative",
                    top:"24px",
                    textAlign:"center",
                    fontFamily:"Roboto",
                    fontSize:"10px",
                    color:"#9B9B9B"
                }}>{props.name}</div></div>
                    </div></div>
                :
                <div><div style={{
                    width:"150px",
                    height:"43px",
                    position: "relative",
                    top:"22px",
                    left:"9px",
                    textAlign:"center",
                    fontFamily:"Roboto",
                    fontSize:"36px",
                    color:"#FFFFFF"
                }}>{props.value}</div><div style={{
                    width:"150px",
                    height:"19px",
                    position: "relative",
                    top:"30px",
                    left:"9px",
                    textAlign:"center",
                    fontFamily:"Roboto",
                    fontSize:"16px",
                    color:"#9B9B9B"
                }}>{props.name}</div></div>
            }
        </div>
    */}
}

class Kpi extends React.Component {

    render() {
        const { classes } = this.props

        return (
            <Paper style={{ backgroundColor: "#FFFFFF", borderRadius: '10px' }}>
                <div>
                    <div style={{ padding: '18px 24px', borderBottomStyle: "solid", borderBottomWidth: "1px", borderBottomColor: "#9B9B9B" }}>
                        <div style={{ fontFamily: "Roboto", fontSize: "20px", fontWeight: 'bold', textTransform: 'uppercase' }}>PEDIDOS</div>
                    </div>
                    <div style={{ padding: "14px", display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <FormControl >
                            <InputLabel shrink htmlFor="filtroTemporal-label-placeholder">
                                Filtro
                            </InputLabel>
                            <Select
                                className={classes.select}
                                value={this.props.idFiltroTemporal || undefined}
                                onChange={this.props.handleOnChange}
                                input={<Input name="filtroTemporal" id="filtroTemporal-label-placeholder" />}
                                displayEmpty
                                name="filtroTemporal">
                                {filtroTemporal.map((x) => (<MenuItem value={x.value}>{x.name}</MenuItem>))}
                            </Select>
                        </FormControl>
                    </div>

                    <div style={{ marginTop: "30px", width: "100%", paddingBottom: "24px" }}>
                        <Kpindicator handleOnClickKpi={this.props.handleOnClickKpi} estado={EstadosPedido.Borrador} color="#40916E" total={this.props.pedidos ? this.props.pedidos[0] : 0} value={this.props.pedidos ? this.props.pedidos[1] : 0} name="Borrador" circulo isTotal={false}></Kpindicator>
                        <Kpindicator handleOnClickKpi={this.props.handleOnClickKpi} estado={EstadosPedido.Confirmado} color="#98A7A1" total={this.props.pedidos ? this.props.pedidos[0] : 0} value={this.props.pedidos ? this.props.pedidos[2] : 0} name="Confirmado" circulo isTotal={false}></Kpindicator>
                        <Kpindicator handleOnClickKpi={this.props.handleOnClickKpi} estado={EstadosPedido.Preparado} color="#414192" total={this.props.pedidos ? this.props.pedidos[0] : 0} value={this.props.pedidos ? this.props.pedidos[7] : 0} name="Informados" circulo isTotal={false}></Kpindicator>
                        <Kpindicator handleOnClickKpi={this.props.handleOnClickKpi} estado={EstadosPedido.Entregado} color="#9B9BA9" total={this.props.pedidos ? this.props.pedidos[0] : 0} value={this.props.pedidos ? this.props.pedidos[8] : 0} name="Informados con error" circulo isTotal={false}></Kpindicator>
                        <Kpindicator handleOnClickKpi={this.props.handleOnClickKpi} estado={EstadosPedido.Eliminado} color="#C9C9E1" total={this.props.pedidos ? this.props.pedidos[0] : 0} value={this.props.pedidos ? this.props.pedidos[6] : 0} name="Eliminados" circulo isTotal={false}></Kpindicator>
                        <Kpindicator handleOnClickKpi={this.props.handleOnClickKpi} estado={EstadosPedido.Abandonado} color="#A67E49" colorBar="#DD2222" total={this.props.pedidos ? this.props.pedidos[0] : 0} value={this.props.pedidos ? this.props.pedidos[5] : 0} name="Abandonados" circulo isTotal={false}></Kpindicator>
                        <Kpindicator handleOnClickKpi={this.props.handleOnClickKpi} estado={undefined} color="#3F6C8E" total={this.props.pedidos ? this.props.pedidos[0] : 0} value={this.props.pedidos ? this.props.pedidos[0] : 0} name="Total" isTotal={true}></Kpindicator>


                    </div>
                </div>

                {/* MODAL FECHAS */}
                <Dialog
                    classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootModal }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='sm'
                    open={this.props.openModal}
                    fullWidth={true}
                >
                    <DialogContent classes={{ root: classes.rootModal }}>

                        <Row style={{ margin: '0px' }}>

                            <Col xs={12} md={12} lg={12} style={{ padding: '0px' }}>
                                <div className='containerModalFechas'>

                                    <div className='labelDescripcionFechas'>Seleccione ambas fechas</div>

                                    <div className='contenidoDateField'>
                                        <TextField className='filterInput'
                                            name='fechaDesde'
                                            type="date"
                                            label="Fecha Desde"
                                            InputLabelProps={{ shrink: true, }}
                                            onChange={this.props.handleOnChangeFecha}
                                        />
                                        <TextField className='filterInput'
                                            name='fechaHasta'
                                            type="date"
                                            label="Fecha Hasta"
                                            InputLabelProps={{ shrink: true, }}
                                            onChange={this.props.handleOnChangeFecha}
                                        />
                                    </div>

                                    {this.props.errorModal !== undefined && <div className='labelErrorModal'>{this.props.errorModal}</div>}

                                    <div className='containerButtonsFechas'>
                                        <Button className='cancelarBtn' onClick={() => this.props.handleOnClickBtnModal()}>
                                            CERRAR
                                        </Button>
                                        <Button className='buscarBtn' onClick={() => this.props.handleOnClickBtnModal(true)}>
                                            BUSCAR
                                        </Button>
                                    </div>

                                </div>
                            </Col>

                        </Row>

                    </DialogContent>
                </Dialog>
            </Paper>
        )
    }
}

Kpi.propTypes = {
    idFiltroTemporal: PropTypes.number,
    openModal: PropTypes.bool,
    errorModal: PropTypes.object,
    handleOnChange: PropTypes.func.isRequired,
    handleOnPedidos: PropTypes.func.isRequired,
    idCatalogo: PropTypes.number,
    pedidos: PropTypes.array.isRequired,
    handleOnChangeFecha: PropTypes.func.isRequired,
    handleOnClickBtnModal: PropTypes.func.isRequired,
    handleOnClickKpi: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(Kpi)